import { Component, OnInit } from '@angular/core';
import * as myLanguages from '../../common/vars_translate';



@Component({
  selector: 'app-tnhomenewslist',
  templateUrl: '../../themes/default/html/tnhomenewslist.component.html',
  styleUrls: ['../../themes/default/css/tnhomenewslist.component.css']
})
export class TnhomenewslistComponent implements OnInit {

  HomeAd: any;

  constructor() {
    this.HomeAd = Object.assign([],myLanguages.translations_IT.HomeAd);
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnhomenewslist/tnhomenewslist.component.ts